
<!-- Estrellas -->
<div class="d-flex align-items-start mt-1" style="margin-left: 2em">
        <ng-container *ngFor="let star of starArray">
          <img
            *ngIf="star <= rate"
            class="mr-1"
            width="12"
            height="12"
            src="../../../../../../assets/icons/itinerary/estrella-01.svg"
            alt="estrella"
          />
          <img
            class="mr-1"
            *ngIf="star > rate"
            width="12"
            height="12"
            style="filter: grayscale(1); opacity: 0.5"
            src="../../../../../../../assets/icons/itinerary/estrella-01.svg"
            alt="estrella"
          />
        </ng-container>
</div>

<!-- Direccion -->
<div class="d-flex align-items-start mt-2" style="margin-left:2em">
  <i class="bi bi-geo-alt-fill" aria-hidden="true" style="font-size: 14px; color: black; line-height: 1"></i>
  <p class="rubik-regular-12pt mb-0 pr-5 ml-1" style="margin-top: 2px;min-height:24px">{{result.additionalInfo?.location}}</p>
</div>

<!-- Boton ver en mapa -->
<p
   class="rubik-regular-12pt mt-2 mb-0"
   style="cursor: pointer; font-weight: 500;margin-left:3em;filter: brightness(.85)"
   [ngStyle]="{'color': clientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
   (click)="openModal('maps');"
   >Ver en mapa
</p>

<!-- Valoracion de producto -->
<ng-container *ngIf="result?.additionalInfo?.comments">
  <p class=" mb-0 d-flex align-items-center mt-2 " style="margin-left:3em;font-weight: 500!important;  font-family: 'Rubik', sans-serif!important;font-size: 12px !important;color: #666666;line-height: 1;">
    <span class="d-flex align-items-center" *ngIf="result?.additionalInfo?.comments?.average_stars > 0">
    <span
          style="display: flex; justify-content: center; align-items: center;background-color: black;border-radius: 50%;width: 17px;font-size: 12px !important"
          [ngStyle]="{'color': clientsSettingAppBooking?.clients_setting_global?.color_main_1}"
          >{{result?.additionalInfo?.comments?.average_stars * 2}}
    </span>
    <span *ngIf="result?.additionalInfo?.comments?.average_stars > 0" style="margin-left: 3px;font-style: italic;font-size: 12px !important">{{getCommentadjective(result?.additionalInfo?.comments?.average_stars)}}</span></span>
      <span *ngIf="result?.additionalInfo?.comments?.average_stars === 0" style="height: 22px"></span>
    <span style="font-style: italic;font-size: 12px !important"  [ngStyle]="{
                     'color': result?.additionalInfo?.comments?.average_stars > 0 ? 'black' : '#bbbbbb',
                     'margin-left': result?.additionalInfo?.comments?.average_stars > 0 ? '3px' : ''
                    }"
          > {{result?.additionalInfo?.comments?.average_stars > 0 ? 'puntuación' : 'Sin puntuación'}}
    </span>
  </p>
</ng-container>

<!-- Descripcion -->
 <div class="d-flex flex-column justify-content-end" style="height: 100%">
  <ng-container *ngIf="result?.description">
  <div class=" pr-4 mt-2 py-2" style="border-top: .5px solid #cccccc;">
    <p class="rubik-regular-12pt mb-0 pr-2" style="line-height: 1.2;margin-left:3em">{{result.description | truncate : 120 : "  "}}
      <span (click)="openModal('info');" class="rubik-regular-12pt" style="cursor: pointer;font-weight: 500">...más</span>
    </p>
  </div>
</ng-container>
<ng-container *ngIf="result.description === ''">
  <div class=" pr-4 mt-2 py-2 " style="border-top: .5px solid #cccccc;">
    <p class="rubik-regular-12pt mb-0 pr-2" style="margin-left:3em;line-height: 1.2;height:40.56px">No hay información acerca de este hotel.</p>
  </div>
</ng-container>

<!-- Adicionales -->
<div class="d-flex py-2" style="border-top: .5px solid #cccccc; height: 67px">
  <div  style="width: 100%;padding-left: 2.3em">
    <div class="d-flex flex-column">
      <p class=" rubik-regular-12pt" style="font-weight: 500;color: black;margin-bottom: 4px">Adicionales</p>
    </div>
    <ng-container *ngIf="result?.additionalInfo?.rooms[0]?.room?.extras && result?.additionalInfo?.rooms[0]?.room?.extras.length > 0">
      <ng-container *ngIf="getAddons(result?.additionalInfo?.rooms[0]?.room?.extras).length > 0 ">
        <div class="d-flex align-items-center" style="gap: 10px">
          <ng-container *ngFor="let addon of getAddons(result?.additionalInfo?.rooms[0]?.room?.extras)">
            <img [src]="addon.image"
                 style="width: 24px;"
                 [tooltip]="addon.tooltip"
                 placement="bottom"
                 alt="addon icon">
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="getAddons(result?.additionalInfo?.rooms[0]?.room?.extras).length === 0 ">
        <p class="mb-1 rubik-regular-12pt" style="font-weight: 600;color: black;">
          N/A
        </p>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="result?.additionalInfo?.rooms[0]?.room?.extras && result?.additionalInfo?.rooms[0]?.room?.extras.length === 0">
        <p class="mb-1 rubik-regular-12pt" style="font-weight: 600;color: black;">
          N/A
        </p>
    </ng-container>
 </div>

  </div>
</div>


